<template>
  <div class="page__single page__datenschutz">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Systembenachrichtigungen</h1>
        </div>
      </div>
      
      <div class="row">
        <div class="row">
          <div class="btn btn-danger" v-on:click="sendUserEmailBatch()">Emails versenden</div>
          <div class="btn btn-danger" v-on:click="deleteAllUsers()">Accounts löschen</div>
        </div>
      </div>
      <div class="row mt-10">
       <div class="col-12">
         <table
             id="dtMaterialDesignExample"
             class="table table-striped"
             cellspacing="0"
             width="100%"
         >
           <thead>
           <tr>
             <th class="th-sm">
               Vorname
             </th>
             <th class="th-sm">
               Nachname
             </th>
             <th class="th-sm">letzter Login</th>
             <th class="th-sm">Versendet?</th>
           </tr>
           </thead>
           <tbody>

           <tr class="entry--item my-5" v-for="item in currentPageData">

             <td>{{item.vorname}}</td>
             <td>{{item.nachname}}</td>
             <td>{{item.logintime | date("DD.MM.YYYY - HH:mm:ss")}}</td>
             <td>{{item.systemmail }}</td>

             <td>
               <!--<mdb-btn color="info" v-on:click="detailsMieter(item.email)">Details</mdb-btn>-->
             </td>
           </tr>


           </tbody>
         </table>
         <div class="pagination d-flex ">
           <div class="pagination__btn prev"  v-on:click="paginationPrev">Zurück</div>
           <span>Seite {{currentPage}} von {{maxPages}} </span>
           <div class="pagination__btn next" v-on:click="paginationNext">Nächste</div>
         </div>
       </div>
      </div>

    </div>

  </div>
</template>

<script>
import EmailService from "../services/EmailService";
import UserService from "../services/UserService";
export default {
  name: "Systemmessages",
  data(){
    return{
      userList: [],
      emailBatchSize: 25,
      currentPage: 1,
      itemsPerPage: 25,
    }
  },
  methods: {
    deleteAllUsers(){
      for (let i = 0; i < this.userList.length; i++) {
        UserService.deleteUserVermieter(this.userList[i].persistence_object_identifier, this.userList[i].persistence_object_identifier);
      }
    },
    async sendUserEmailBatch(){
      let counter = 0;
      for (let i = 0; i < this.userList.length; i++) {
        if(counter >= this.emailBatchSize){

          this.getUserList();
          await new Promise(resolve => setTimeout(resolve, 30000)); // 300 sec
          this.sendUserEmailBatch();
          return
        }
        if(this.userList[i].systemmail == 0){
          counter++;
          let user = JSON.stringify(this.userList[i]);
          console.log("Send Mail to:", this.userList[i].accountidentifier);
          EmailService.sendMail("deleteInfoVermieter", "Achtung dringend! Wohnungsdatenbank Account Info", this.userList[i].accountidentifier, user, true);
          UserService.setUserSystemMailStatus(this.userList[i].accountidentifier);
          await new Promise(resolve => setTimeout(resolve, 5000)); // 5 sec

        }
      }
    },
    getUserList(){
      EmailService.getSystemMailListVermieter().then(response =>{
        if(response.data.length > 0){
          this.userList = response.data;
        }
      })
    },
    paginationPrev(){
      if(this.currentPage > 1){
        this.currentPage--;
      }
    },
    paginationNext(){

      if(this.currentPage +1 <= this.maxPages){
        this.currentPage++;
      }
    },
  },
  mounted() {
    this.getUserList();
  },
  computed: {
    maxPages(){
      return Math.floor(this.userList.length / this.itemsPerPage);
    },
    currentPageData(){
      return this.userList.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
    }
  }
}
</script>

<style scoped>

</style>